import store from '../../store';
import * as ACTIONS from './action';

const obj = {
    sliceString:(str, length)=>{
        if(str && str.toString().length > length) {
            return str.slice(0, length)+"...";
        }
        return str;
    },
    setLoading:(val, message)=>store.dispatch(ACTIONS.setLoading(val, message)),
    getEventCategories:(val)=>store.dispatch(ACTIONS.getEventCategories(val)),
    getEventsByCategoryId:(val)=>store.dispatch(ACTIONS.getEventsByCategoryId(val)),
    toggleCodeVerification:(val)=>store.dispatch(ACTIONS.toggleCodeVerification(val)),
    setActiveRole:(val)=>store.dispatch(ACTIONS.setActiveRole(val)),
    getRoles:(val)=>store.dispatch(ACTIONS.getRoles(val)),
    getSwallowEO:(val)=>store.dispatch(ACTIONS.getSwallowEO(val)),
}

export default obj;